import React, { useState, useEffect } from "react";
import {
  Card,
  Typography,
  AutoComplete,
  Input,
  Button,
  Table,
  Spin,
  Divider,
  notification,
} from "antd";
import { SearchOutlined, EyeOutlined,ArrowLeftOutlined  } from "@ant-design/icons";
import axios from "axios";
import { BASE_URL } from "../../App";
import Report from './Service_Claim_BM_Approval';

const { Title, Text } = Typography;

const NewScReport = () => {
  const [branch, setBranch] = useState(null);
  const [branches, setBranches] = useState([]);
  const [docNo, setDocNo] = useState("");
  const [tokenNo, setTokenNo] = useState("");
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [showTable, setShowTable] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [selectedReport, setSelectedReport] = useState(null);
  
  const filteredData = searchText
    ? data.filter((item) =>
        item.DOC_NO?.toString().toLowerCase().includes(searchText.toLowerCase())
      )
    : data;

  
  const login_id = localStorage.getItem("LOGIN_ID");
  const user_branch = localStorage.getItem("BRANCH_CODE");

  

  useEffect(() => {
    fetchBranches();
  }, []);

  const fetchBranches = async () => {
    try {
      const response = await axios.post(`${BASE_URL}/branchfornewscreport`, {
        login_id,
        user_branch,
      });

      const mappedBranches = (response.data.branches || []).map((branch) => ({
        label: `${branch.code} - ${branch.name}`,
        value: branch.code,
      }));

      setBranches(mappedBranches);
    } catch (error) {
      console.error("Error fetching branches:", error);
      notification.error({ message: "Failed to load branches" });
    }
  };

  const handleView = async () => {
    setLoading(true);
    setShowTable(true);
if (!branch?.value) {
	 setLoading(false);
  notification.error({
    message: "Info",
    description: "Branch should not be empty.",
    placement: "topRight",
  });
  return;
}
    try {
      const response = await axios.post(`${BASE_URL}/newscreportview`, {
        login_id,
        user_branch,
        branch: branch?.value || "",
      });

      setData(response.data.documents || []);
    } catch (error) {
      console.error("Error fetching report:", error);
      notification.error({ message: "Failed to fetch report" });
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = async () => {
    setLoading(true);
    setShowTable(true);

    if (!docNo && !tokenNo) {
      notification.warning({ message: "Please enter either Doc No or Token No" });
      setLoading(false);
      return;
    }

    const type = docNo ? "DOCNO" : "TOKENNO";
if (!branch?.value) {
	 setLoading(false);
  notification.error({
    message: "Info",
    description: "Branch should not be empty.",
    placement: "topRight",
  });
  return;
}

if ((type === "DOCNO" && !docNo) || (type === "TOKENNO" && !tokenNo)) {
	 setLoading(false);
  notification.error({
    message: "Info",
    description: `${type === "DOCNO" ? "Doc No" : "Token No"} should not be empty.`,
    placement: "topRight",
  });
  return;
}
    try {
      const response = await axios.post(`${BASE_URL}/newscreportsearch`, {
        login_id,
        user_branch,
        branch: branch?.value || "",
        doc_no: docNo || "",
        tokenNo: tokenNo || "",
        type,
      });

      setData(response.data.documents || []);
    } catch (error) {
      console.error("Error:", error);
      notification.error({ message: "Failed to fetch data" });
    } finally {
      setLoading(false);
    }
  };

  const handleFinalReportClick = (item) => {
    // Show Report component with selected Doc No and Serial No
    setSelectedReport({ doc_no: item.DOC_NO, serial_no: item.SERIAL_NO });
  };

  const handleBackToTable = () => {
    setSelectedReport(null); // Reset report view
  };
  const columns = [
    {
      title: "Action",
      dataIndex: "action",
      render: (_, item) => (
        <Text
          style={{ color: "#1890ff", cursor: "pointer" }}
          onClick={() => handleFinalReportClick(item)}
        >
          View
        </Text>
      ),
    },
    {
      title: "Doc No.",
      dataIndex: "DOC_NO",
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <Input
            placeholder="Search Doc No"
            value={selectedKeys[0]}
            onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={() => confirm()} // Trigger search on enter
            style={{ marginBottom: 8, display: "block" }}
          />
          <Button type="primary" onClick={() => confirm()} size="small" style={{ marginRight: 8 }}>
            Search
          </Button>
          <Button onClick={() => clearFilters()} size="small">
            Reset
          </Button>
        </div>
      ),
      filterIcon: (filtered) => (
        <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
      ),
      onFilter: (value, record) =>
        record.DOC_NO?.toString().toLowerCase().includes(value.toLowerCase()),
    },
    { title: "Serial No.", dataIndex: "SERIAL_NO" },
    { title: "Service Call No.", dataIndex: "SERVICECALL_NO" },
    { title: "Created By", dataIndex: "CREATEDBY" },
    { title: "ASC Name", dataIndex: "ASC_NAME" },
    { title: "Name of Creator", dataIndex: "CREATEDBY_NAME" },
  ];

  return (
    <div style={{ padding: "20px" }}>
      <Card>
         {selectedReport ? (
          // If report is selected, show Report Component
          <>
            <Button onClick={handleBackToTable} icon={<ArrowLeftOutlined />} style={{ marginBottom: 10 }}>
              Back
            </Button>
            <Report doc_no={selectedReport.doc_no} serial_no={selectedReport.serial_no} />
          </>
        ) : (
            <>
        <Title level={4} style={{ color: "#117864", marginBottom: "16px" }}>
          {/* SERVICE CLAIM Report */}
        </Title>

        {/* Branch Selection & Search */}
        <div style={{ display: "flex", gap: "16px", flexWrap: "wrap", alignItems: "center" }}>
          
          {/* Branch Selection */}
          <div style={{ display: "flex", gap: "8px", flex: 1, minWidth: "300px" }}>
            <AutoComplete
              options={branches}
              value={branch?.label}
              onChange={(value, option) => setBranch(option)}
              placeholder="Select Branch"
              style={{ width: "100%" }}
            />
            <Button type="primary" onClick={handleView} disabled={loading} icon={<EyeOutlined />}>
              {loading ? <Spin size="small" /> : "VIEW"}
            </Button>
          </div>

          <Divider type="vertical" style={{ height: "32px" }} />

         
          <div style={{ display: "flex", gap: "8px", flex: 1, minWidth: "300px" }}>
            <Input placeholder="Document Number" value={docNo} onChange={(e) => setDocNo(e.target.value)} />
            <Text strong>or</Text>
            <Input placeholder="Token Number" value={tokenNo} onChange={(e) => setTokenNo(e.target.value)} />
            <Button type="primary" danger onClick={handleSearch} disabled={loading} icon={<SearchOutlined />}>
              {loading ? <Spin size="small" /> : "SEARCH"}
            </Button>
          </div>

        </div>

       
        {showTable && (
            
         <Table
           columns={columns}
           dataSource={filteredData}
           rowKey="DOC_NO"
           pagination={{ pageSize: 5 }}
         />
        
        )}
        </>
    )}
      </Card>
    </div>
  );
};

export default NewScReport;
